import { render } from "./MySelect.vue?vue&type=template&id=0b1a76f4"
import script from "./MySelect.vue?vue&type=script&lang=js"
export * from "./MySelect.vue?vue&type=script&lang=js"

import exportComponent from "E:\\OpenServer\\domains\\vue\\vue-catalog\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__